import React from "react";

import {
    Clock3,
    Bike,
    CheckCircle2,
    XCircle
} from "lucide-react";

import "./OrderTabs.css";

function OrderTabs({

    activeTab,

    setActiveTab,

    counts,

}) {

    const tabs = [

        {

            id: "pending",

            label: "Pending",

            count: counts?.pending || 0,

            icon: <Clock3 size={18} />

        },

        {

            id: "active",

            label: "Active",

            count: counts?.active || 0,

            icon: <Bike size={18} />

        },

        {

            id: "completed",

            label: "Completed",

            count: counts?.completed || 0,

            icon: <CheckCircle2 size={18} />

        },

        {

            id: "cancelled",

            label: "Cancelled",

            count: counts?.cancelled || 0,

            icon: <XCircle size={18} />

        }

    ];

    return (

        <div className="hf-order-tabs">

            {

                tabs.map((tab)=>(

                    <button

                        key={tab.id}

                        className={

                            activeTab===tab.id

                                ? "hf-order-tab active"

                                : "hf-order-tab"

                        }

                        onClick={()=>

                            setActiveTab(tab.id)

                        }

                    >

                        <div className="hf-tab-left">

                            {tab.icon}

                            <span>

                                {tab.label}

                            </span>

                        </div>

                        <div className="hf-tab-count">

                            {tab.count}

                        </div>

                    </button>

                ))

            }

        </div>

    );

}

export default OrderTabs;